import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "topbar"
};
const _hoisted_2 = {
  class: "header-filters",
  gap: 28
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "Dashboard", -1);
const _hoisted_4 = {
  class: "toolbar"
};
const _hoisted_5 = {
  class: "navigation-wrapper"
};
const _hoisted_6 = {
  key: 0,
  class: "kpi-card-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dashboard_filters = _resolveComponent("dashboard-filters");
  const _component_currency_filter = _resolveComponent("currency-filter");
  const _component_navigation_tabs = _resolveComponent("navigation-tabs");
  const _component_period_controllers = _resolveComponent("period-controllers");
  const _component_tabbed_kpi_cards = _resolveComponent("tabbed-kpi-cards");
  const _component_performance_period_table = _resolveComponent("performance-period-table");
  const _component_listing_period_table = _resolveComponent("listing-period-table");
  const _component_advertising_period_table = _resolveComponent("advertising-period-table");
  const _component_profit_period_table = _resolveComponent("profit-period-table");
  const _component_vendor_period_table = _resolveComponent("vendor-period-table");
  const _component_flex_column = _resolveComponent("flex-column");
  const _component_performance_product_table = _resolveComponent("performance-product-table");
  const _component_omny_ui_layout = _resolveComponent("omny-ui-layout");
  return _openBlock(), _createBlock(_component_omny_ui_layout, {
    "content-padding": "0",
    class: "dashboard-v2"
  }, {
    topbar: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_dashboard_filters)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_currency_filter, {
      currencies: _ctx.currencies,
      "only-mode": "",
      onApply: $options.handleApplyForCurrencyChange
    }, null, 8, ["currencies", "onApply"])])])]),
    "topbar-sub": _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_navigation_tabs, {
      tabs: $options.computedTabs,
      modelValue: $options.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.tab = $event)
    }, null, 8, ["tabs", "modelValue"]), _withDirectives(_createVNode(_component_period_controllers, {
      period: $options.period,
      "onUpdate:period": _cache[1] || (_cache[1] = $event => $options.period = $event),
      periodCategory: $options.periodCategory,
      "onUpdate:periodCategory": _cache[2] || (_cache[2] = $event => $options.periodCategory = $event),
      periodOptions: $options.periodOptions,
      periodSelectorOptions: _ctx.periodSelectorOptions
    }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"]), [[_vShow, _ctx.floatingTableState === $data.FLOATING_COMPOUND_TABLE_STATES.FULL_SIZE]])])]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["dashboard-v2-contents", [_ctx.floatingTableState]])
    }, [_createVNode(_component_flex_column, {
      classes: "all-wrapper"
    }, {
      default: _withCtx(() => [['performance', 'advertising', 'listing', 'profit', 'vendor'].includes(_ctx.currentTabValue) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_tabbed_kpi_cards, {
        kpi: _ctx.kpis_v2[_ctx.currentTabValue],
        loading: $data.kpisLoading
      }, null, 8, ["kpi", "loading"])])) : _createCommentVNode("", true), _ctx.currentTabValue === 'performance' ? (_openBlock(), _createBlock(_component_performance_period_table, {
        key: 1,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTable,
        onRefresh: _cache[5] || (_cache[5] = $event => this.refreshMediator(['PERIOD_TABLE']))
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_period_controllers, {
          period: $options.period,
          "onUpdate:period": _cache[3] || (_cache[3] = $event => $options.period = $event),
          periodCategory: $options.periodCategory,
          "onUpdate:periodCategory": _cache[4] || (_cache[4] = $event => $options.periodCategory = $event),
          periodOptions: $options.periodOptions,
          periodSelectorOptions: _ctx.periodSelectorOptions
        }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"])]),
        _: 1
      }, 8, ["loading", "onSetDateRange"])) : _createCommentVNode("", true), _ctx.currentTabValue === 'listing' ? (_openBlock(), _createBlock(_component_listing_period_table, {
        key: 2,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTable,
        onRefresh: _cache[8] || (_cache[8] = $event => this.refreshMediator(['PERIOD_TABLE']))
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_period_controllers, {
          period: $options.period,
          "onUpdate:period": _cache[6] || (_cache[6] = $event => $options.period = $event),
          periodCategory: $options.periodCategory,
          "onUpdate:periodCategory": _cache[7] || (_cache[7] = $event => $options.periodCategory = $event),
          periodOptions: $options.periodOptions,
          periodSelectorOptions: _ctx.periodSelectorOptions
        }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"])]),
        _: 1
      }, 8, ["loading", "onSetDateRange"])) : _createCommentVNode("", true), _ctx.currentTabValue === 'advertising' ? (_openBlock(), _createBlock(_component_advertising_period_table, {
        key: 3,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTable,
        onRefresh: _cache[11] || (_cache[11] = $event => this.refreshMediator(['PERIOD_TABLE']))
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_period_controllers, {
          period: $options.period,
          "onUpdate:period": _cache[9] || (_cache[9] = $event => $options.period = $event),
          periodCategory: $options.periodCategory,
          "onUpdate:periodCategory": _cache[10] || (_cache[10] = $event => $options.periodCategory = $event),
          periodOptions: $options.periodOptions,
          periodSelectorOptions: _ctx.periodSelectorOptions
        }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"])]),
        _: 1
      }, 8, ["loading", "onSetDateRange"])) : _createCommentVNode("", true), _ctx.currentTabValue === 'profit' ? (_openBlock(), _createBlock(_component_profit_period_table, {
        key: 4,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTable,
        onRefresh: _cache[14] || (_cache[14] = $event => this.refreshMediator(['PERIOD_TABLE']))
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_period_controllers, {
          period: $options.period,
          "onUpdate:period": _cache[12] || (_cache[12] = $event => $options.period = $event),
          periodCategory: $options.periodCategory,
          "onUpdate:periodCategory": _cache[13] || (_cache[13] = $event => $options.periodCategory = $event),
          periodOptions: $options.periodOptions,
          periodSelectorOptions: _ctx.periodSelectorOptions
        }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"])]),
        _: 1
      }, 8, ["loading", "onSetDateRange"])) : _createCommentVNode("", true), _ctx.currentTabValue === 'vendor' ? (_openBlock(), _createBlock(_component_vendor_period_table, {
        key: 5,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTable,
        onRefresh: _cache[17] || (_cache[17] = $event => this.refreshMediator(['PERIOD_TABLE']))
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_period_controllers, {
          period: $options.period,
          "onUpdate:period": _cache[15] || (_cache[15] = $event => $options.period = $event),
          periodCategory: $options.periodCategory,
          "onUpdate:periodCategory": _cache[16] || (_cache[16] = $event => $options.periodCategory = $event),
          periodOptions: $options.periodOptions,
          periodSelectorOptions: _ctx.periodSelectorOptions
        }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"])]),
        _: 1
      }, 8, ["loading", "onSetDateRange"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_performance_product_table, {
      loading: $data.productTableLoading,
      onRefreshOtherKpis: _cache[18] || (_cache[18] = $event => this.refreshMediator(['KPIS', 'PERIOD_TABLE'])),
      onRefresh: _cache[19] || (_cache[19] = $event => $options.refreshProductTable()),
      onHandleSort: $options.handleProductTableSort,
      onChangeDate: $options.handleDateChange,
      onRestoreEvolutionTable: $options.restoreEvolutionTable
    }, null, 8, ["loading", "onHandleSort", "onChangeDate", "onRestoreEvolutionTable"])], 2)]),
    _: 1
  });
}